var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCloseRoundDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.66667 10c0-4.5947 3.73863-8.33333 8.33333-8.33333s8.3333 3.73863 8.3333 8.33333-3.7386 8.3333-8.3333 8.3333-8.33333-3.7386-8.33333-8.3333zm11.63253 3.2991c.1478-.1477.1478-.3901 0-.5378l-2.7613-2.7614 2.7613-2.76137c.1478-.14773.1478-.39015 0-.53788-.1477-.14772-.3901-.14772-.5378 0l-2.7614 2.76137-2.76136-2.76137c-.14773-.14772-.39016-.14772-.53788 0-.14773.14773-.14773.39015 0 .53788l2.76136 2.76137-2.76136 2.7614c-.14773.1477-.14773.3901 0 .5378.07576.072.17045.1099.26894.1099.09848 0 .19318-.0379.26894-.1099l2.76136-2.7613 2.7614 2.7613c.0757.072.1704.1099.2689.1099s.1932-.0379.2689-.1099z",
    fill: "#2d2d2d",
    fillRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseRoundDark);
export default __webpack_public_path__ + "static/media/ico_close_round_dark.410127ef05833f52c50efc0813f111cb.svg";
export { ForwardRef as ReactComponent };